import React from 'react';
import Button from '../../forms/Button';
import Input from '../../forms/Input';
import Form from '../forms/FullScreenForm';
import { Link } from 'react-router-dom';
import { ROOT_PATH } from '../../../constants/routes';

const ChangePasswordForm = props => {
    return (
        <Form
            onSubmit={props.onSubmit}
            canSubmit={props.canSubmit}
            header={'Change Password'}
            body={
                <React.Fragment>
                    <Input
                        label="Old password"
                        name="oldPassword"
                        type="password"
                        value={props.oldPassword}
                        onChange={props.onInput}
                        error={props.oldPasswordError}
                        errorMessage={props.oldPasswordError}
                    />
                    <Input
                        label="New password"
                        name="newPassword"
                        type="password"
                        value={props.newPassword}
                        onChange={props.onInput}
                        error={props.newPasswordError}
                        errorMessage={props.newPasswordError ? 'should be longer than 5 characters' : ''}
                    />
                    <Input
                        label="New password confirmation"
                        name="newPasswordConfirmation"
                        type="password"
                        value={props.newPasswordConfirmation}
                        onChange={props.onInput}
                        error={props.newPasswordConfirmationError}
                        errorMessage={props.newPasswordConfirmationError ? 'should match the new password' : ''}
                    />
                </React.Fragment>
            }
            withCancel={true}
            footer={
                <React.Fragment>
                    <Button loading={props.loading} inactive={!props.canSubmit} label="Change Password" />
                    <Link className="ckp-forms-cancel" to={ROOT_PATH}>
                        Cancel
                    </Link>
                </React.Fragment>
            }
        />
    );
};

export default ChangePasswordForm;
